import axios from "axios"

export async function createClassWalletPendingOrder(data: { planName: string, studentCount: number }): Promise<{ orderId: string }> {
    const res = await axios.post("/api/classwallet-pending", data)
    return res.data
}
